export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 6"],
    category: "height",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "height",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          name: "number",
        },
      ],
    },
  },
);
